import { Form, FormProps, Input } from "antd";
import PasswordPrefixIcon from "../../../assets/icons/PasswordPrefixIcon";
import { ModalType } from "../../../types";
import FormModal from "../../ui/FormModal";
import { useAppDispatch } from "../../../store/store";
import { resetUserPasswordAsync } from "../../../store/features/csoManager/user/userApi";

type Props = {
  open: ModalType;
  handleClose: () => void;
};

export default function ResetPassword({ open, handleClose }: Props) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const onFinish: FormProps<any>["onFinish"] = (values) => {
    const userId = open?.data?._id;
    
    if (!userId) {
      console.error("User ID not found");
      return;
    }

    dispatch(
      resetUserPasswordAsync({
        data: {
          newPassword: values.password
        },
        others: {
          id: userId,
          reRender: () => {
            handleClose();
          }
        }
      })
    );
  };

  return (
    <FormModal
      open={open?.open}
      isUpdate={open?.type === "RESET_PASSWORD"}
      title="Password Reset"
      onFinish={onFinish}
      handleClose={handleClose}
      buttonText="Reset Password"
      formProps={{
        form,
      }}
    >
      <Form.Item
        name="password"
        label="New Password"
        rules={[
          { required: true, message: "Please enter new password" },
          {
            min: 8,
            message: "Password must be minimum 8 characters",
          },
        ]}
      >
        <Input.Password
          placeholder="Enter new password"
          prefix={<PasswordPrefixIcon />}
        />
      </Form.Item>

      <Form.Item
        name="passwordConfirm"
        label="Confirm New Password"
        rules={[
          {
            required: true,
            message: "Please confirm new password",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("The two passwords do not match!")
              );
            },
          }),
        ]}
      >
        <Input.Password
          placeholder="Confirm new password"
          prefix={<PasswordPrefixIcon />}
        />
      </Form.Item>
    </FormModal>
  );
}
